// Where signing in goes: the page asked for before the login (kept by the router as the last page), else the
// dashboard. Never back to the login or sign-up page itself, never an outside address.
export function afterLoginPath(lastPage) {
  var p = typeof lastPage === 'string' ? lastPage.trim() : ''
  if (!p || p === '/' || p.charAt(0) !== '/' || p.indexOf('//') === 0) return '/'
  if (/^\/(login|signup)(\/|\?|#|$)/i.test(p)) return '/'
  return p
}
